<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import ContactLeadForm from './ContactLeadForm.vue'
import type { ContactBlock, WebsiteLeadCaptureState, WebsiteLeadSubmission } from '../../types'

defineProps<{ block: ContactBlock; leadCapture?: WebsiteLeadCaptureState }>()
const emit = defineEmits<{ leadSubmit: [submission: WebsiteLeadSubmission] }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-surface) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:max-w-3xl">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div class="site:mt-10 site:grid site:border-y site:border-(--site-color-border) site:@min-[48rem]:grid-cols-2 site:@min-[64rem]:grid-cols-4">
        <div v-for="method in block.content.methods" :key="method.id" class="site:border-b site:border-(--site-color-border) site:py-7 site:@min-[48rem]:border-r site:@min-[48rem]:px-6 site:@min-[48rem]:first:pl-0 site:@min-[64rem]:border-b-0">
          <SiteEditableText v-model="method.label" as="p" class="site:text-xs site:font-bold site:tracking-wider site:text-(--site-color-muted-text) site:uppercase" />
          <SiteLink :link="method.link" class="site-heading site:mt-3 site:inline-block site:text-lg site:font-bold site:text-(--site-color-primary)">{{ method.link.label }}</SiteLink>
        </div>
        <div v-if="block.content.hours" class="site:border-b site:border-(--site-color-border) site:py-7 site:@min-[48rem]:px-6 site:@min-[64rem]:border-b-0 site:@min-[64rem]:border-r">
          <p class="site:text-xs site:font-bold site:tracking-wider site:text-(--site-color-muted-text) site:uppercase">Hours</p>
          <SiteEditableText v-model="block.content.hours" as="p" class="site-heading site:mt-3 site:text-lg site:font-bold" />
        </div>
        <div v-if="block.content.address" class="site:py-7 site:@min-[48rem]:px-6 site:@min-[48rem]:last:pr-0">
          <p class="site:text-xs site:font-bold site:tracking-wider site:text-(--site-color-muted-text) site:uppercase">Service area</p>
          <SiteEditableText v-model="block.content.address" as="p" class="site-heading site:mt-3 site:text-lg site:font-bold" />
        </div>
      </div>

      <ContactLeadForm v-if="leadCapture?.enabled" :lead-capture="leadCapture" @submit="emit('leadSubmit', $event)" />
      <SiteLink v-else-if="block.content.primaryAction" :link="block.content.primaryAction" class="site-site-button site:mt-8">{{ block.content.primaryAction.label }}</SiteLink>
    </div>
  </section>
</template>
